module.exports = __webpack_public_path__ + "static/media/cmt_icon4.97601acf.png";